// extracted by mini-css-extract-plugin
export default {"row":"ResultsWrapper_row__Op6qP"};